import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, XCircle, Warning, WhatsappLogo } from "@phosphor-icons/react";
import { api, inr } from "@/lib/api";
import { CONTACT } from "@/data/site";

export default function PaymentStatus() {
  const [params] = useSearchParams();
  const txnid = params.get("txnid");
  const [payment, setPayment] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!txnid) { setError(true); return; }
    api.get(`/payments/status/${txnid}`).then((r) => setPayment(r.data)).catch(() => setError(true));
  }, [txnid]);

  if (error) return (
    <div className="py-32 text-center" data-testid="payment-status-page">
      <p className="text-[#8B89A4]">Payment record not found.</p>
      <Link to="/packages" className="mt-4 inline-block text-brand-teal font-medium">Browse packages</Link>
    </div>
  );
  if (!payment) return <div className="py-32 text-center text-[#8B89A4]" data-testid="payment-status-page">Checking payment status...</div>;

  const ok = payment.status === "success";
  const flagged = payment.status === "flagged";

  return (
    <div className="max-w-xl mx-auto px-5 py-20" data-testid="payment-status-page">
      <div className="rounded-3xl bg-white p-8 md:p-10 shadow-[0_12px_40px_rgba(46,42,128,0.12)] text-center">
        {ok ? (
          <CheckCircle size={72} weight="fill" className="mx-auto text-green-500" data-testid="payment-success" />
        ) : flagged ? (
          <Warning size={72} weight="fill" className="mx-auto text-amber-500" data-testid="payment-flagged" />
        ) : (
          <XCircle size={72} weight="fill" className="mx-auto text-red-500" data-testid="payment-failed" />
        )}
        <h1 className="mt-5 font-heading text-3xl font-semibold text-brand-navy">
          {ok ? "Payment Successful! 🎉" : flagged ? "Payment Under Verification" : "Payment Failed"}
        </h1>
        <p className="mt-2 text-[#6b6a8a] font-body text-sm">
          {ok
            ? `Thank you ${payment.name}! Aapki advance payment mil gayi hai. Hamari team jald hi booking confirm karegi.`
            : flagged
            ? "Payment receive hui hai but verification pending hai. Hamari team jald contact karegi."
            : payment.error_message || "Payment complete nahi ho payi. Aap dobara try kar sakte hain."}
        </p>

        <div className="mt-6 rounded-xl bg-brand-cream border border-brand-sand p-4 text-left text-sm space-y-2">
          <div className="flex justify-between"><span className="text-[#8B89A4]">Package</span><span className="font-semibold text-brand-navy text-right">{payment.package_title}</span></div>
          <div className="flex justify-between"><span className="text-[#8B89A4]">Amount paid</span><span className="font-bold text-brand-orange">{inr(payment.amount)}{payment.advance_percent < 100 ? ` (${payment.advance_percent}% advance)` : ""}</span></div>
          {payment.advance_percent < 100 && (
            <div className="flex justify-between"><span className="text-[#8B89A4]">Package price</span><span className="text-brand-navy">{inr(payment.total_price)}</span></div>
          )}
          <div className="flex justify-between"><span className="text-[#8B89A4]">Txn ID</span><span className="font-mono text-xs text-brand-navy">{payment.txnid}</span></div>
        </div>

        <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
          {ok || flagged ? (
            <a
              href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(`Hi Cluetrip! Maine "${payment.package_title}" ke liye ${inr(payment.amount)} advance pay kar diya hai (Txn: ${payment.txnid}). Please confirm my booking.`)}`}
              target="_blank" rel="noreferrer" data-testid="payment-whatsapp"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-7 py-3.5 text-sm font-bold text-white"
            >
              <WhatsappLogo size={18} weight="fill" /> Confirm on WhatsApp
            </a>
          ) : (
            <Link to="/packages" className="rounded-full bg-brand-orange px-7 py-3.5 text-sm font-bold text-white" data-testid="payment-retry">
              Try Again
            </Link>
          )}
          <Link to="/" className="rounded-full border-2 border-brand-teal px-7 py-3 text-sm font-bold text-brand-teal">Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
